import { useTranslation } from 'react-i18next'
import type { BookingToken } from './types'

type TerminalStatus = BookingToken['status'] | 'confirmed'

interface Props {
	status: TerminalStatus
	// Optional override; when omitted the default copy for the status is used.
	message?: string | null
}

const ICON: Record<NonNullable<TerminalStatus>, string> = {
	pending: '',
	confirmed: '✓',
	booked: '✓',
	cancelled: '×',
	expired: '⏱',
	invalidated: '×',
}

const MESSAGE_KEYS = {
	pending: 'terminal.default',
	confirmed: 'terminal.confirmed',
	booked: 'terminal.booked',
	cancelled: 'terminal.cancelled',
	expired: 'terminal.expired',
	invalidated: 'terminal.invalidated',
} as const satisfies Record<NonNullable<TerminalStatus>, string>

export function TerminalStateScreen({ status, message }: Props) {
	const { t } = useTranslation('booking')
	const icon = ICON[status] ?? '×'
	const text = message ?? t(MESSAGE_KEYS[status] ?? 'terminal.default')
	const isConfirmed = status === 'confirmed'

	return (
		<div className="flex min-h-screen flex-col items-center justify-center px-6 text-center">
			<div
				className={`flex h-16 w-16 items-center justify-center rounded-full text-2xl ${
					isConfirmed ? 'bg-green-100 text-green-600' : 'bg-gray-100 text-gray-400'
				}`}
			>
				{icon}
			</div>
			<p className="mt-6 max-w-sm text-base text-gray-500">{text}</p>
		</div>
	)
}
